import {useEffect, useRef, useState} from 'react';

import {Divider} from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import {useWindowSize} from '@uidotdev/usehooks';
import {bool, element, func, node, object, oneOf, oneOfType} from 'prop-types';

import {BREAKPOINTS} from '../../../const';
import useBreakpoint from '../../../hooks/dom/useBreakpoint';
import {moduleCategoryShape} from '../../../proptypes-shapes';
import BaseModal from '../../modal/BaseModal';
import PopperComponent from '../PopperComponent/PopperComponent';
import SingleReportModule from '../SingleReportModule/SingleReportModule';

// eslint-disable-next-line react/prop-types
const ModulesListPopper = ({isNestedInPopper, onClose, anchorEl, renderModulesList}) => {
  const containerRef = useRef(null);
  const windowSize = useWindowSize();
  const [arrowPixelsFromBottom, setArrowPixelsFromBottom] = useState(0);

  useEffect(() => {
    const popperHeight = containerRef?.current?.clientHeight ? containerRef.current.clientHeight : 0;
    const pixelsFromBottom = popperHeight / 2 - 10;
    setArrowPixelsFromBottom(pixelsFromBottom);
  }, [windowSize.width, containerRef?.current, renderModulesList]);

  return (
    <PopperComponent
      placement="right"
      hasArrow
      arrowStyle={{
        bottom: arrowPixelsFromBottom,
        position: 'absolute',
        left: isNestedInPopper ? 0 : 8
      }}
      paperStyle={{
        mb: 0,
        minHeight: 55,
        minWidth: 140,
        ml: isNestedInPopper ? 2.8 : 3.5
      }}
      onClose={onClose}
      anchorEl={anchorEl}
      isOpen
    >
      <Box ref={containerRef}>
        <Grid container flexDirection="column" maxWidth={260}>
          {renderModulesList()}
        </Grid>
      </Box>
    </PopperComponent>
  );
};

const ModulesList = ({category, isNestedInPopper, anchorEl, onClose}) => {
  const currentBreakpoint = useBreakpoint();
  const isSmallScreen = currentBreakpoint === BREAKPOINTS.xs || currentBreakpoint === BREAKPOINTS.sm;

  const groupedBySubcategoryModules = category.modules.reduce((acc, item) => {
    if (!acc[item.category]) {
      acc[item.category] = [];
    }
    acc[item.category].push(item);
    return acc;
  }, {});

  const renderModulesList = () => {
    return Object.entries(groupedBySubcategoryModules).map(([subcategory, subcategoryModules], index) => {
      const isLastSubcategory = index === Object.keys(groupedBySubcategoryModules).length - 1;
      return (
        <div key={subcategory}>
          {subcategoryModules.map(m => (
            <SingleReportModule key={m.id} module={m} />
          ))}
          {!isLastSubcategory ? <Divider /> : null}
        </div>
      );
    });
  };

  if (isSmallScreen) {
    return (
      <BaseModal
        hasTransition
        title={`Choisir un module "${category.label}"`}
        hasTitleDivider={false}
        hasCloseIcon
        onClose={onClose}
        open
        isFullScreen
        sx={{
          zIndex: 9999
        }}
      >
        <Box px={2} py={3}>
          {renderModulesList()}
        </Box>
      </BaseModal>
    );
  }

  return <ModulesListPopper isNestedInPopper={isNestedInPopper} renderModulesList={renderModulesList} anchorEl={anchorEl} onClose={onClose} />;
};

ModulesList.propTypes = {
  category: moduleCategoryShape.isRequired,
  isNestedInPopper: bool.isRequired,
  onClose: func.isRequired,
  anchorEl: oneOfType([object, element, node, oneOf([null])])
};

export default ModulesList;
